import * as React from "react";
import { User } from "../../../userTypes";

type Props = {
  user: User;
};

export default class RiskAssessment extends React.Component<Props> {
  render() {
    const { user } = this.props;

    return (
      <section className="page">
        <table
          style={{
            fontSize: "14px",
            paddingTop: "-30px",
            width: "100%",
          }}
          className="BOTable"
          cellPadding={0}
          cellSpacing={0}
        >
          <thead>
            <tr>
              <td colSpan={6}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <p style={{ flex: 1 }}>RelyComply risk assessments</p>
                </h3>
              </td>
            </tr>

            {user.risk_assessment_history != null ? (
              <tr>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Customer risk status</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Customer risk completed</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Risk score</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Created at</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Updated at</b>
                </th>
              </tr>
            ) : (
              <tr />
            )}
          </thead>
          {user.risk_assessment == null ? (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> There are no risk assessment records for this user. </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {user.risk_assessment_history.map((assessment, index) => {
                return (
                  <tr key={index}>
                    <td> {assessment.risk_status} </td>
                    <td> {assessment.risk_completed} </td>
                    <td> {assessment.risk_score} </td>
                    <td> {assessment.created_at} </td>
                    <td> {assessment.updated_at} </td>
                  </tr>
                );
              })}
            </tbody>
          )}
        </table>
      </section>
    );
  }
}
